import { combineReducers } from 'redux';

import { REQUEST_DISENROLLMENT, SUCCESS_DISENROLLMENT, FAILURE_DISENROLLMENT } from './constants';

const successDisenrollmentRequestSubmit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_DISENROLLMENT:
            return true;
        case REQUEST_DISENROLLMENT:
        case FAILURE_DISENROLLMENT:
            return false;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_DISENROLLMENT:
            return true;
        case FAILURE_DISENROLLMENT:
        case SUCCESS_DISENROLLMENT:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_DISENROLLMENT:
            return action.response.message;
        case REQUEST_DISENROLLMENT:
        case SUCCESS_DISENROLLMENT:
            return '';
        default:
            return state;
    }
};

export default combineReducers({ successDisenrollmentRequestSubmit, fetching, error });



// WEBPACK FOOTER //
// ./src/services/disenrollment/reducer.js